import React from 'react';
import { Home, Users, ClipboardCheck, ClipboardList, CalendarClock, ShieldCheck, BarChart3, Newspaper, Bot, LogOut } from 'lucide-react';

const ITEMS = [
  { key: 'dashboard', path: '/admin/dashboard', label: 'Dashboard', Icon: Home },
  { key: 'leads', path: '/admin/leads', label: 'Leads', Icon: Users },
  { key: 'quiz', path: '/admin/quiz', label: 'Quiz', Icon: ClipboardCheck },
  { key: 'pesquisa', path: '/admin/pesquisa', label: 'Pesquisa', Icon: ClipboardList },
  { key: 'agendamentos', path: '/admin/agendamentos', label: 'Agendamentos', Icon: CalendarClock },
  { key: 'lgpd', path: '/admin/lgpd', label: 'LGPD', Icon: ShieldCheck },
  { key: 'analytics', path: '/admin/analytics', label: 'Visitas', Icon: BarChart3 },
  { key: 'blog', path: '/admin/blog', label: 'Blog', Icon: Newspaper },
  { key: 'agente', path: '/admin/agente', label: 'Agente IA', Icon: Bot },
];

export const AdminNav = ({ active, navigate, sidebarOpen = true, onLogout }) => (
  <nav className="space-y-2">
    {ITEMS.map(({ key, path, label, Icon }) => (
      <button
        key={key}
        onClick={() => navigate(path)}
        data-testid={`nav-${key}-btn`}
        className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${active === key ? 'bg-yellow-500/20 text-yellow-400' : 'text-gray-400 hover:bg-gray-800'}`}
      >
        <Icon className="w-5 h-5" />{sidebarOpen && <span>{label}</span>}
      </button>
    ))}
    <button onClick={onLogout} className="w-full flex items-center gap-3 px-4 py-3 text-red-400 hover:bg-red-500/10 rounded-lg transition-colors mt-8">
      <LogOut className="w-5 h-5" />{sidebarOpen && <span>Sair</span>}
    </button>
  </nav>
);

export default AdminNav;
